import React from "react";

const AuthBanner = () => {
  return (
    <div className="relative md:w-2/3 w-full" style={{ backdropFilter: "invert(1)" }}>
      {/* Banner Image */}
      <img
        src="/images/banner.png"
        alt="Banner"
        className="absolute inset-0 w-full h-full object-center"
      />
      {/* Optional Overlay (darkens image for better text contrast) */}
      <div className="absolute inset-0 bg-opacity-40"></div>

      {/* Text Overlay */}
      <div className="relative z-10 flex flex-col justify-center h-full px-8 py-12 text-white">
        <div className="max-w-md">
          <h1 className="text-4xl font-semibold mb-4 leading-tight">
            Committed to People, <br />
            Committed to the Future
          </h1>
          <p className="text-lg mb-6">
            We have an unwavering drive to make the world better.
            We’re built on the promise of a new day.
          </p>
          <button className="bg-red-600 text-white py-2 px-6 rounded-md">
            Our Philosophy and Strategy
          </button>
        </div>
      </div>
    </div>
  );
};

export default AuthBanner;